import { useOeeThresholds } from "@/hooks/useOrganizationPolicy";
import { thresholdColor } from "./oee-thresholds";
import { OverrunBadge } from "./OverrunBadge";

interface Props {
  label: string;
  value: number | null;
  // Texto exibido quando value é null (ex.: "Insuficiente" p/ Qualidade, "—" p/ Disponibilidade).
  nullLabel: string;
  // Destaque de "pior" (gargalo) no card de decomposição.
  worst?: boolean;
}

// Indicador por máquina (cor + dot + label, nunca só cor). Usado na tela da máquina
// e no card de decomposição da linha. NÃO é um OEE composto — é um componente isolado (A ou Q).
export function MachineMetric({ label, value, nullLabel, worst = false }: Props) {
  // Spec 079 — a régua de cor vem da organização, não de constante. Cai no padrão da coluna
  // enquanto a query não respondeu, para o dot nunca nascer cinza e mudar de cor sozinho.
  const thresholds = useOeeThresholds();
  return (
    <div className="flex items-center gap-1.5">
      <span
        className={`h-2 w-2 shrink-0 rounded-full ${thresholdColor(value, thresholds)}`}
        aria-hidden
      />
      <span className="text-[11px] text-muted-foreground">{label}</span>
      <span className="font-mono text-xs font-semibold text-foreground">
        {value === null ? nullLabel : `${value.toFixed(1)}%`}
      </span>
      {/* Mesma marcação da linha, pelo mesmo primitivo. Hoje ela NÃO dispara por
          máquina: `operating` da máquina é derivado (`planned − down`) e o downtime é recortado
          contra o mesmo conjunto que produziu o planned, então `down ≤ planned` é invariante e a
          Disponibilidade não passa de 100%. Usar o primitivo compartilhado em vez de omitir custa
          uma linha e garante que, se a definição de `operating` por máquina algum dia mudar, as
          duas telas não divirjam sobre como desenhar hora extra. */}
      <OverrunBadge value={value} metricLabel={label} />
      {worst ? (
        <span className="bg-rd-danger-500/15 rounded px-1 text-[10px] font-medium text-rd-danger-700">
          pior
        </span>
      ) : null}
    </div>
  );
}
